import React, { Component, createRef, Fragment } from "react";
import {
  Hero,
  Title,
  TechniqueTitle,
  ClientTag,
  CaseWrapper,
  BackButton,
  BackArrow
} from "../styles/Case.styles";

import Reveal from 'react-reveal/Reveal';
import { withRouter } from "react-router";
import Footer from '../components/Footer';
import { Efectr, Efectr1, Efectr2  } from "../styles/effect.styles";

export const ScrollTop = ({ children, location }) => {
  React.useEffect(() => window.scrollTo(0, 0), [location])
  return children
}

class Case extends Component {
  constructor(props) {
    super(props);
    this.introRef = createRef();

    this.state = {
          toBack: false,
          introTop: 0,
          hasBackground: false,
          animateCase: ""
        };
      }
    
      componentDidUpdate() {
        if (this.state.toBack) {
          setTimeout(() => {
            this.props.setNavBackground(false);
            this.props.history.push("/blog");
          }, 400);
        }
        if (this.state.animateCase) {
          setTimeout(() => {
            this.props.setNavBackground(false);
    
            this.props.history.push(this.state.animateCase);
            window.scrollTo(0, 0);
          }, 400);
        }
      }
    
    
      render() {
        return (
          <Fragment>
          <Efectr/>
          <Efectr1/>
          <Efectr2/>
          <ScrollTop>
            <CaseWrapper>
              <Reveal effect="fadeIn">
                <Hero className='mainhero' style={{ backgroundImage: "url('./img/news/AllLrg.png')" }}>
                    <div className='herocaption'>
                      <BackButton className='backdetail'
                        onClick={() => this.setState({ toBack: true, hasBackground: false })}
                        toBack={this.state.toBack}
                        hasBackground={this.state.hasBackground}>
                        <BackArrow src="./img/back.png" alt="Back to blog" />
                        <span>Back </span>
                      </BackButton>
                      <div className='container'>
                        <div className='row'>
                          <div className='col-md-12 pl-md-0'>
                            <ClientTag className='date'>April 22, 2024</ClientTag>
                            <Title>It's Just my Allergies!</Title>
                            <TechniqueTitle>
                            Reaching for the Kleenex and eye drops rather than the sunglasses with warmer weather?
                            </TechniqueTitle>
                          </div>
                        </div>
                      </div>
                    </div>
                </Hero>
              </Reveal>
    
              <section className='container' id='detailproject'>
                <div className='row'>
                  <div className='col-md-12'>
                    <p className='content'>Seasonal allergies are common, affecting nearly 1 in every 7 adults worldwide. These allergies occur when the immune system overreacts to airborne particles such as pollen, mold spores, or dust mites, leading to symptoms of sneezing, nasal congestion, itchy eyes, and throat irritation. Seasonal allergies are typically triggered by the release of pollen from trees, grasses, and weeds during specific times of the year, depending on the allergen and geographic location.</p>
                    <p className='content'>While season allergies are not usually life threatening, seasonal allergies can significantly impact an individual’s quality of life, disrupting sleep, work, and daily activities. Furthermore, individuals with seasonal allergies are more likely to develop additional co-morbidities such as eczema, food intolerances and/or asthma due to the rise in histamine levels within the body. </p>
                     <p className='content'> Although the best way to prevent seasonal allergies is to avoid triggers, avoidance is not always possible. Thankfully there are natural and effective remedies to alleviate symptoms!</p>

                  
                    <h3 className='my-5'>Natural Seasonal Allergy Remedies</h3>
                    <div>
                      <p className='content'>1. N-acetyl-cysteine (NAC): Expectorant & mucus thinner; helps to reduce congestion. </p>
                      <p className='content'> 2. Nettle extract: Potent anti-inflammatory effects; shown to reduce sneezing & itching. </p>
                      <p className='content'>3. Vitamin C & D3: Anti-oxidant effects and natural anti-histamine. </p>
                      <p className='content'> 4. Quercetin: Reduces chance of having symptom exacerbations by ~50% & reduces the number of days requiring rescue medications. </p>
                      <p className='content'>5.Bromelain: Enhances quercetin’s absorption; Reduces swelling, breaks up mucus, & improves respiratory congestion.</p>
                      <p className='content'>6.Butterbur: Shown to relieve allergy symptoms as effectively as antihistamine drugs in clinical trials.</p>
                      <p className='content'>7. Expert help: Speak with your naturopathic doctor to customize a migraine protocol specific for you! </p>
                    </div>
                  </div>  

                  <div className='col-md-12'></div>
                  <div className='share'>
                    <span className='heading'>
                    Share this blog post :
                    </span>
                    <span className='content'> 
                    <a href="https://www.facebook.com/sharer/sharer.php?u=drmichellemaliknd.com/WOW6" target="_blank" rel="noopener noreferrer">  
                      <i className="fa fa-facebook-f"></i>
                      </a>  
                    </span>
                    <span className='content'> 
                    <a href="https://www.instagram.com/dr.michellemalik.nd" target="_blank" rel="noopener noreferrer">   
                      <i className="fa  fa-instagram"></i>
                      </a>
                    </span>
                  </div>
                </div>
              </section>

            </CaseWrapper>

                      </ScrollTop>
                
                      <Footer />
                
                      </Fragment>
                    );
                  }
                }
                
                export default withRouter(Case);